import type { NeffiStatus } from '@xing-com/crate-jobs-domain-apply-types';

const HIGH_QUALITY_THRESHOLD = 80;
const MEDIUM_QUALITY_THRESHOLD = 50;

export const getNeffiScoreStatus = (normalizedScore: number): NeffiStatus => {
  if (normalizedScore >= HIGH_QUALITY_THRESHOLD) {
    return 'high';
  }
  if (normalizedScore >= MEDIUM_QUALITY_THRESHOLD) {
    return 'medium';
  }
  return 'low';
};
